import ApplyRounding from "../../../../../../../utils/math/ApplyRounding";

export function bounceDetailParser(_root, softOrder) {
  const tradePlanId = softOrder.tradePlanId;
  const tacticValue = softOrder.value.tacticValue;
  const priceToBreak = tacticValue.priceToBreak || null;
  let breakPrice = null;
  if (priceToBreak) breakPrice = ApplyRounding(priceToBreak, 2);
  return {
    details: {
      breakPrice,
      tradePlanId
    },
    triggerPrice: {
      priceToBreak: breakPrice,
    }
  }
}